import React from 'react';
import styled from 'styled-components';

import { Color } from 'modules/styles/colors';
import { FontFamily, FontSize, Spacing } from 'modules/styles/variables';
import SmallText from 'components/UI/Typography/SmallText';

interface Props {
  items: Item[];
  itemKey?: string;
  selected?: object | string | null;
  onSelection: (value: object) => void;
  placeholder?: string;
  requiredLabel?: boolean;
  error?: string | null;
  customInputStyle?: object;
  disabled?: boolean;
  accessibilityLabel?: string;
  ref?: any;
  onDonePress?: () => void;
}

const inputStyle = (disabled: boolean | undefined) => ({
  alignItems: 'flex-start',
  backgroundColor: disabled ? Color.grayLight2 : Color.foreColor,
  borderWidth: 1,
  borderColor: Color.grayHue4,
  color: Color.textDark,
  fontFamily: FontFamily.primary,
  fontSize: FontSize.large,
  lineHeight: 20,
  letterSpacing: 0.5,
  minHeight: 42,
  paddingTop: 6,
  paddingBottom: 6,
  paddingLeft: 10,
  paddingRight: 10,
  width: '100%'
});

const Container = styled.div`
  width: 100%;
`;

const RequiredLabel = styled(SmallText)`
  right: 10px;
  position: absolute;
  top: 9px;
  color: ${Color.red};
`;

const ErrorText = styled(SmallText)`
  margin-top: ${Spacing.medium};
  color: ${Color.red};
`;

const getPickerSelectStyles = (disabled: boolean | undefined) => ({
  viewContainer: {
    width: '100%'
  },
  inputIOS: inputStyle(disabled),
  inputAndroid: inputStyle(disabled)
});

const InputPicker = React.forwardRef(
  (
    {
      items,
      itemKey,
      onSelection,
      placeholder,
      selected,
      requiredLabel,
      error,
      customInputStyle,
      disabled,
      accessibilityLabel,
      onDonePress
    }: Props,
    ref
  ) => {
    return (
      // <Container accessibilityLabel={accessibilityLabel}>
      //   <PickerSelect
      //     items={items}
      //     disabled={disabled}
      //     itemKey={itemKey}
      //     placeholder={{
      //       label: placeholder,
      //       value: null
      //     }}
      //     style={customInputStyle || getPickerSelectStyles(disabled)}
      //     useNativeAndroidPickerStyle={false}
      //     value={selected}
      //     onValueChange={value => onSelection(value)}
      //     ref={ref}
      //     onDonePress={onDonePress}
      //   />
      //   {requiredLabel ? <RequiredLabel>*</RequiredLabel> : null}
      //   {error ? <ErrorText>{error}</ErrorText> : null}
      // </Container>
      <Container accessibilityLabel={accessibilityLabel}>
        <div>PickerSelect</div>
        {requiredLabel ? <RequiredLabel>*</RequiredLabel> : null}
        {error ? <ErrorText>{error}</ErrorText> : null}
      </Container>
    );
  }
);

InputPicker.defaultProps = {
  items: [],
  itemKey: 'id',
  selected: null,
  placeholder: 'Make a selection',
  disabled: false
};

export default InputPicker;

// TODO: Find PickerSelect
